import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CashDrawerStaff } from "./CashDrawerStaff";
import type { OrderRef } from "./OrderRef";
import type { PrinterDTOBase } from "./PrinterDTOBase";
import type { TrackedModernBase } from "./TrackedModernBase";

export class PrinterStaff implements PrinterDTOBase, TrackedModernBase {
  constructor(public readonly printerMAC: string, public readonly printerName: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly cashDrawers: Array<CashDrawerStaff> | null) {
    this.cbiServiceContext = null;
    this.cashDrawersLoaded = this.cashDrawers != null;
    this.cashDrawersCached = this.cashDrawers;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private cashDrawersLoaded: boolean;
  private cashDrawersCached: Array<CashDrawerStaff> | null;
  async cashDrawersLazy(): Promise<Array<CashDrawerStaff>> {
    if (!this.cashDrawersLoaded) {
      this.cashDrawersCached = await this.cbiServiceContext!.printerService().getPrinterStaffCashDrawers(this.printerMAC);
      this.cashDrawersLoaded = true;
    }
    return this.cashDrawersCached!;
  }
  async hasPassword(): Promise<boolean> {
    return await this.cbiServiceContext!.printerService().hasPasswordStaff({ printerMAC: this.printerMAC });
  }
  async online(): Promise<boolean> {
    return await this.cbiServiceContext!.printerService().onlineStaff({ printerMAC: this.printerMAC });
  }
  async pendingJobs(): Promise<number> {
    return await this.cbiServiceContext!.printerService().pendingJobsStaff({ printerMAC: this.printerMAC });
  }
  async printReceipt(order: OrderRef): Promise<string> {
    return await this.cbiServiceContext!.printerService().printReceiptStaff({ printer: { printerMAC: this.printerMAC }, order: order });
  }
  async printTest(): Promise<string> {
    return await this.cbiServiceContext!.printerService().printTestStaff({ printerMAC: this.printerMAC });
  }
  async setCredentials(username: string | null, password: string | null): Promise<void> {
    return await this.cbiServiceContext!.printerService().setCredentialsStaff({ printer: { printerMAC: this.printerMAC }, username: username, password: password });
  }
}
